/*
 *Commonly used keys
 * like success; failure; access token etc.
 *
 * Add or remove variables according to your requirement
 */

export const SUCCESS_KEY = 'success';
export const ERROR_KEY = 'error';
export const PROGRESS_KEY = 'progress';
export const FAILURE_KEY = 'failure';
export const COMPLETE_KEY = 'complete';

export const PERSIST_KEY = 'root'

export const ACCESS_KEY = '@heal-second-opinion/access-token';
export const PRE_SIGNUP_FILES_KEY = '@heal-second-opinion/pre-signup-files';

// keystrokes keys
export const KEYSTROKE_ENTER = 'Enter';

// keys for specialist onboarding status
export const SELECT_SPECIALIST_CHECKPOINT = 'specialist-select-checkpoint';
export const SIGNUP_LICENSE_FILE_KEY = "@heal-second-opinion/license-file";
// specialist filter keys
export const SPECIALIST_FILTER_SPECIALITY_KEY = '@heal-second-opinion/specialist-filters';
/**
 * these are group of test-id keys used for unit testing, they are maintained
 * to keep unified and sturcture way to pass key to the component without
 * accidently missspelling it.
 */
export const TestIDKeys = {
  /**
   * signup screen keys
   */
  signupFormNameInput: 'signup-form-name-input',
  signupFormEmailInput: 'signup-form-email-input',
  signupFormSubmitButton: 'signup-form-submit-button',
  signupFormPhoneInput: 'signup-form-phone-input',

  /**
   * login screen keys
   */
  loginFormEmailInput: 'login-form-email-input',
  loginFormSubmitButton: 'login-form-submit-button',

  /**
   * header
   */
  headerLogo: 'header-logo',
  headerBG: 'header-bg',

  /**
   * OTP form
   */
  otpFormInput: 'otp-form-input',
  otpBackButton: 'otp-back-button',
  otpResendButton: 'otp-resend-button',
  otpSubmitButton: 'otp-submit-button',

  /**
   * view profile screen
   */
  profileNameLabel: 'profile-name-label',
  profileEmailLabel: 'profile-email-label',
  profilePhoneLabel: 'profile-phone-label',
  profileAgeLabel: 'profile-age-label',
  profileAddressLabel: 'profile-address-label',
  profileEditButton: 'profile-edit-button',
  profilePhoto: 'profile-photo',

  /**
   * contact component
   */
  contactContainer: 'contact-container',
  contactHeading: 'contact-heading',
  contactSubheading: 'contact-subheading',
  contactForm: 'contact-form',
  contactEmailInput: 'contact-email-input',
  contactMessageInput: 'contact-message-input',
  contactSubmitButton: 'contact-submit-button',
};
